import { cosmicApi } from './clients';

const accessKey: { [key: string]: string } = {
  vnshop: 'ulISdNDAN9MMpNCfXhTOSNQdh9tF0xXOL65PdIz6cfw7J319cG',
  karavan: 'N0VNt8uGaO0QxlXLEKGcIsKiqGYeuejw0AK4YeYjla0A1qLlVN',
  umbala: '5KihnfendgNLL7k4zZVjBiwE27nYcKcuz6kwxpTXHo8AxYPrRf',
  vinmart: '6OC98OJNAOT9qzq1g6t6UnP72zqOt5tXMurVJ2qELvKovQX70M',
  cpvn: 'vXraTMSIWKfTpYZX1YV9LO8XX0Q5pQXLRr9kgGlri635EUlisf',
  takashimaya: 'JOUu6Kf1RuuSHfsegx2fkzd13NJSCcrOvxXB6gI6QpYIna4LCv',
  vnpay: 'ZvfT9WRG2KZ2dEF8tCRaKgbJZRdqhG0XckUHzkBhHy8XaGHK7K',
  ipp: 'YO71gfq1uvrjBaScttrzp4CV6rs5oOfzq4dvrdFACH13wYEHEr',
  soibien: 'FjourKXWwl12MoIDd4nj0ZxMwS18G2OUva7wSW6b3iG95Z92x6',
  meatdeli: 'TvYF1WNXCIH7bU6dMebRkSyW2dVI3WtZUz2iEogVFjxRtRSuPH',
  apaos: 'xn1DNyDK4UtDVvPCYBQNcjD5bWOw0XqE6zF69pOt0tWJPFnEpW',
  'policy-sms': 'rNPixiLvJ5s198BVppBXvtyNQVStxByvWFJ2PaRB8qknX79Saw',
  cyhome: 'KJ0plXySpMdrFnGJWZjk7jbuu9TK3bZWlsrYwxXO6pUqQMNG1r',
  maxtrust: 'iWJlZ86Rrnxo1OW10exkeFiXiQIVbMO9J6HKHVe6TCaZz1U6Yp',
};
/*
 * map tenant name to bucket slug name
 * if they are not the same
 * */
const cosmicPath: { [key: string]: string } = {
  cp: 'cpvn',
  sms: 'policy-sms',
};

const getApiKey = (tenant: string) => {
  return accessKey[cosmicPath[tenant] || tenant];
};

const cosmicService = {
  getSlugs: async (tenant: string) => {
    const readKey = getApiKey(tenant);
    if (!readKey) return [];

    const resp = await cosmicApi.get(
      `/${cosmicPath[tenant] || tenant}/objects`,
      {
        params: {
          pretty: true,
          hide_metafields: true,
          props: 'slug,title',
          read_key: readKey,
        },
      },
    );

    return resp?.data?.objects;
  },
  getPost: async (slug: string, tenant: string) => {
    const readKey = getApiKey(tenant);
    if (!readKey) return null;
    const resp = await cosmicApi.get(
      `/${cosmicPath[tenant] || tenant}/object/${slug}`,
      {
        params: {
          hide_metafields: true,
          type: 'posts',
          props: 'slug,title,content',
          read_key: readKey,
        },
      },
    );

    return resp?.data?.object;
  },
};

export default cosmicService;
